<template>
  <div class="chat-wedget-hx">
    <el-tooltip
      v-if="isHx"
      class="item"
      effect="dark"
      :content="translateTitle('汇信介绍')"
      popper-class="wedget-tooltip"
      placement="left"
    >
      <div
        class="chat-wedget-circle-n movies"
        @click="
          () => {
            moviesVisible = true;
          }
        "
      ></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="translateTitle('在线客服')"
      popper-class="wedget-tooltip"
      placement="left"
    >
      <el-badge :value="noRead" class="item" :hidden="!noRead" :max="99">
        <div
          class="chat-wedget-circle-n servies"
          v-if="!visible"
          @click="onChatClick"
        ></div>
      </el-badge>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="translateTitle('联系TG')"
      popper-class="wedget-tooltip"
      placement="left"
    >
      <div class="chat-wedget-circle-n tg" @click="onTgClick"></div>
    </el-tooltip>
    <div class="chat-wedget-box" v-if="visible" v-loading="frameLoad">
      <div class="close" @click="onClose">
        <i class="iconfont iconicon-close black" v-if="customer_type == 1"></i>
        <img class="icon" src="../../assets/img/close.png" alt="" />
      </div>
      <iframe id="iframe" :src="frameUrl" frameborder="0"></iframe>
    </div>
    <div class="video-content" v-if="moviesVisible">
      <div class="close-outer">
        <i
          class="iconfont iconicon-close close"
          @click="
            () => {
              moviesVisible = false;
            }
          "
        ></i>
      </div>
      <video
        class="video"
        width="584"
        poster="../../assets/img/home/video-page.png"
        controls
        :src="currentVideo"
        frameborder="0"
        muted
        loop="true"
        autoplay="autoplay"
      ></video>
    </div>
  </div>
</template>

<script>
import { VUE_APP_ID, VUE_UNION_STATION } from "@/assets/js/stationSetting";
import { mapActions, mapGetters } from "vuex";
import { mapState } from "vuex";
import Cookies from "js-cookie";
import { apiGetAssets } from "@/model/exchange/index";
import { apiGetcustermerUrl } from "@/model/home/index";
import { userLoginLogList } from "@/model/ucenter/assets";
import { translateTitle } from "@/assets/js/i18n";
import CryptoJS from "crypto-js";
const md5 = require("md5");
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // const frameUrl = `https://customer-service.hxexchge.com/?token=${token}`;
    return {
      VUE_UNION_STATION,
      visible: false,
      frameUrl: "",
      apiAssetsInfo: "",
      ipInfo: "",
      token: "",
      isHx: true,
      customer_type: 0,
      customer_service_url: "",
      noRead: "",
      frameLoad: true,
      currentVideo:
        "https://static.topcreditbank.com/video/about/topcredit-cn.mp4",
      moviesVisible: false,
    };
  },
  async created() {
    this.token = Cookies.get("topcredit_exchange_t");
    if (VUE_UNION_STATION == "TopCredit") {
      this.isHx = true;
    }
    await this.getcustermerUrl();
    //  this.customer_service_url = sessionStorage.getItem("customer_service_url");
  },
  mounted() {},
  methods: {
    translateTitle,
    onTgClick() {
      window.open("https://t.me/Topcredit017");
    },
    async getcustermerUrl() {
      const { status, data } = await apiGetcustermerUrl();
      if (status == 200) {
        let tempHost = window.location.host;
        this.customer_service_url = data.customer_service_url;
        this.customer_type = data.customer_type;
        this.frameUrl =
          this.customer_service_url +
          `/?token=${this.token}&host=${tempHost}&lang=${this.language}#is_hide`;
      }
    },
    onChatClick() {
      this.visible = true;
      // let tempUrl = sessionStorage.getItem("customer_service_url");
      // this.customer_type = sessionStorage.getItem("customer_type");
      let tempHost = window.location.host;

      if (this.customer_type == "1") {
        this.frameUrl = this.customer_service_url;
      } else {
        this.frameUrl =
          this.customer_service_url +
          `/?token=${this.token}&host=${tempHost}&lang=${this.language}#is_show`;
      }
      setTimeout(() => {
        this.frameLoad = false;
      }, 1500);
    },
    onClose() {
      this.visible = false;
      this.frameLoad = true;
      // let tempUrl = sessionStorage.getItem("customer_service_url");
      // this.customer_type = sessionStorage.getItem("customer_type");
      let tempHost = window.location.host;

      if (this.customer_type == "1") {
        this.frameUrl = this.customer_service_url;
      } else {
        this.frameUrl =
          this.customer_service_url +
          `/?token=${this.token}&host=${tempHost}&lang=${this.language}#is_hide`;
      }
    },
    startTimer() {
      this.initStatus().then(rs => {
        setTimeout(() => {
          if (this.destroyed) {
            return;
          }
          this.startTimer();
        }, 10000);
      });
    },
    initStatus() {
      return apiIngOrder().then(rs => {
        const { status, data } = rs;
        if (status == 200) {
          this.noRead = +data.fast_gm_no_read;
          // this.noRead = (+1);
        }
      });
    },
    getUeCustomerServer() {
      let params = {};
      if (this.userInfo) {
        //登陆
        let req = {};
        req.uid = this.userInfo.accountInfo.account_id;
        req.mobile = this.userInfo.accountInfo.mobile;
        req.email = this.userInfo.accountInfo.email;
        req.userName = this.userInfo.accountInfo.username;

        req.userIp = this.ipInfo;
        req.account = this.apiAssetsInfo;

        req.language = localStorage.getItem("language") || "zh_CN";
        // console.log(this.encrypt(this.changStr(req)));
        let tempData = this.encrypt(this.changStr(req));

        let domain = "https://kf.jhdami.com/";
        params.appid = "csc1679554722821";
        params.code = "BD6u7";
        params.channelType = "1";
        params.language = localStorage.getItem("language") || "zh_CN";
        params.nonceStr = "k6ih17s0ppm6esnw02it12";
        params.data = tempData;
        let sign = this.getSign(params);
        this.customer_service_url =
          domain + "?" + this.changStr(params) + "&sign=" + sign;
        // console.log("----", this.customer_service_url);
      } else {
        //未登录
        this.customer_service_url =
          "https://kf.jhdami.com?code=BD6u7&channelType=1&tenantPlatCode=youyi";
      }
    },
    changStr(req) {
      let str = "";
      for (let i in req) {
        str += i + "=" + req[i] + "&";
      }
      str = str.substr(0, str.length - 1);
      return str;
    },
    getSign(params) {
      for (let key in params) {
        params[key] =
          params[key] || params[key] === 0 || params[key] === false
            ? params[key]
            : "";
      }
      let keys = Object.keys(params);
      let length = keys.length;
      keys = keys.sort();
      let sign = "";
      for (let i = 0; i < length; i++) {
        if (sign != "") sign = sign + "&";
        sign = sign + keys[i] + "=" + params[keys[i]];
      }
      sign = md5(sign)
        .toString()
        .toUpperCase();
      return sign;
    },
    // 加密
    encrypt(word, keyStr) {
      keyStr = keyStr
        ? this.sort_ASCII(keyStr)
        : "PRoxb3f1yTIYX3IgZ6SUWqAcJEI3IDJG";
      let key = CryptoJS.enc.Utf8.parse(keyStr);
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    // ascii从小到达排序
    sort_ASCII(arr) {
      arr.sort((a, b) => {
        return a.charCodeAt(0) - b.charCodeAt(0);
      });
    },
    async getAssets() {
      if (!this.userInfo) {
        return;
      }
      let params = {
        type: "remain",
      };
      const { status, data } = await apiGetAssets(params);
      if (status == 200) {
        this.apiAssetsInfo = data.remain.u_valuation;
      }
    },
    async userLoginLogList() {
      if (!this.userInfo) {
        return;
      }
      let pamars = { page_size: 1 };
      await userLoginLogList(pamars).then(({ status, data, msg }) => {
        if (status === 200) {
          this.ipInfo = data.list[0].login_ip;
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      language: "user/language",
      userInfo: "user/userInfo",
    }),
    // ...mapState({
    //   userInfo: state => state.user.info,
    // }),
  },
  watch: {
    dialogVisible() {
      this.onChatClick();
    },
  },
};
</script>

<style lang="scss">
.chat-wedget-hx {
  position: fixed;
  // right: 40px;
  right: 60px;
  bottom: 17%;
  .el-badge__content.is-fixed {
    top: -48px !important;
  }

  cursor: pointer;
  z-index: 99999;
  .chat-wedget-circle {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    position: absolute;
    right: 0;
    bottom: 0;
    background: #c61b3d url("../../assets/img/chat-wedget-white.png") no-repeat
      center;
    background-size: 60%;
  }
  .chat-wedget-circle-n {
    margin: 6.3px 0;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    // position: absolute;
    position: relative;
    right: 0;
    bottom: 0;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  }
  .servies {
    background: url("../../assets/img_n/theme/servies.png") no-repeat;
    background-size: 100%;
    &:hover {
      background: url("../../assets/img_n/theme/servies_h.png") no-repeat;
      background-size: 100%;
    }
  }
  .movies {
    background: url("../../assets/img_n/theme/movies.png") no-repeat;
    background-size: 100%;
    &:hover {
      background: url("../../assets/img_n/theme/movies_h.png") no-repeat;
      background-size: 100%;
    }
  }
  .tg {
    background: url("../../assets/img_n/theme/tg.png") no-repeat;
    background-size: 100%;
    &:hover {
      background: url("../../assets/img_n/theme/tg_h.png") no-repeat;
      background-size: 100%;
    }
  }
  .chat-wedget-text {
    position: absolute;
    color: #c61b3d;
    top: 10px;
    right: -40px;
    width: 130px;
    text-align: center;
    font-size: 14px;
  }
  .chat-wedget-box {
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 430px;
    height: 720px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    iframe {
      width: 100%;
      height: 100%;
    }
    .close {
      position: absolute;
      right: 10px;
      top: 8px;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconicon-close {
        color: white;
      }
    }
  }
  .video-content {
    width: 584px;
    height: 328.5px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    .close-outer {
      width: 100%;
      height: 33px;
      // background-color: #000;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      z-index: 100;
      position: absolute;
      .close {
        margin-right: 12px;
        margin-top: -3px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
